
export enum ToolbarLocation {
    Top = 'Top',
    Bottom = 'Bottom'
}

export function toToolbarLocation(toolbarLocationValue: string) {
    switch(toolbarLocationValue){
        case "Top": return ToolbarLocation.Top;
        case "Bottom": return ToolbarLocation.Bottom;
        default: return ToolbarLocation.Bottom;
    }
}

export enum TimeMode {
    Clock = 'Clock',
    CountDown = 'Count Down',
    CountUp = 'Count Up',
    None = 'None'
}

export default interface PresenterPreferences {
    countdownTime: number;
    fontSize: number;
    timeMode: TimeMode;
    timerEnabled: boolean;
    toolbarLocation: ToolbarLocation;
}